<template>
  <div id="app">
    <div v-if="this.$route.path == '/login'">
      <router-view />
    </div>
    <div v-else>
      <div id="app__header">
        <h4>PSPP Sertifikat System</h4>
        <span @click="logout"> {{ this.$user.nama }} | Logout <logout /> </span>
      </div>
      <div id="app__sidebar">
        <ul>
          <li>
            <router-link
              to="/sertifikat/belum-validasi"
              :class="{ active: $route.params.status == 'belum-validasi' }"
            >
              Belum Divalidasi <span>{{ summary.belum_validasi }}</span>
            </router-link>
          </li>
          <li>
            <router-link
              to="/sertifikat/pending"
              :class="{ active: $route.params.status == 'pending' }"
            >
              Pending <span>{{ summary.pending }}</span>
            </router-link>
          </li>
          <li>
            <router-link
              to="/sertifikat/validasi"
              :class="{ active: $route.params.status == 'validasi' }"
            >
              Sudah Divalidasi <span>{{ summary.validasi }}</span>
            </router-link>
          </li>
          <li>
            <router-link
              to="/sertifikat/dikirim"
              :class="{ active: $route.params.status == 'dikirim' }"
            >
              Sudah Dikirim <span>{{ summary.dikirim }}</span>
            </router-link>
          </li>
          <li>
            <router-link
              to="/sertifikat/diterima"
              :class="{ active: $route.params.status == 'diterima' }"
            >
              Diterima <span>{{ summary.diterima }}</span>
            </router-link>
          </li>
          <li>
            <router-link
              to="/sertifikat/ditolak"
              :class="{ active: $route.params.status == 'ditolak' }"
            >
              Ditolak <span>{{ summary.ditolak }}</span>
            </router-link>
          </li>
          <li>
            <router-link
              to="/sertifikat/retur"
              :class="{ active: $route.params.status == 'retur' }"
            >
              Retur <span>{{ summary.retur }}</span>
            </router-link>
          </li>
        </ul>
      </div>
      <div id="app__content">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import Logout from "./components/icons/Logout.vue";
import * as api from "./api/Api";

export default {
  name: "App",
  components: {
    Logout,
  },
  data() {
    return {
      summary: {
        pending: 0,
        validasi: 0,
        dikirim: 0,
        diterima: 0,
        ditolak: 0,
        retur: 0,
      },
    };
  },
  methods: {
    summarize() {
      api.get("/v1/SertifikatController/summary").then((r) => {
        if (r.valid) {
          this.summary.pending = r.data.PENDING;
          this.summary.belum_validasi = r.data.BELUM_VALIDASI;
          this.summary.validasi = r.data.VALIDASI;
          this.summary.dikirim = r.data.DIKIRIM;
          this.summary.diterima = r.data.DITERIMA;
          this.summary.ditolak = r.data.DITOLAK;
          this.summary.retur = r.data.RETUR;
        }
      });
    },
    logout() {
      localStorage.clear();
      location.reload();
    },
  },
  mounted() {
    this.summarize();

    if (this.$route.path != "/login") {
      if (!this.$store.state.settings.user.id) {
        this.$router.push("/login");
      }
    }

    if (this.$route.path == "/") {
      this.$router.push("/sertifikat/pending");
    }
  },
  watch: {
    $route(to) {
      this.summarize();
      if (to.path == "/") {
        this.$router.push("/sertifikat/pending");
      }
    },
  },
};
</script>

<style lang="scss">
body {
  margin: 0;
  background: #f5f7f9;
}

* {
  font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI",
    "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#app {
  &__header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 45px;
    background: #344955;
    color: #fff;
    z-index: 1;
    line-height: 45px;
    display: flex;
    justify-content: space-between;

    h4 {
      margin: 0;
      padding-left: 15px;
    }

    span {
      font-size: 14px;
      display: flex;
      margin-right: 15px;
      cursor: pointer;
      .icon {
        width: 20px;
        margin-left: 5px;
      }
    }
  }

  &__sidebar {
    position: fixed;
    top: 45px;
    left: 0px;
    width: 200px;
    height: calc(100% - 45px);
    background: #eaecee;
    border-right: 1px solid #ddd;
    color: #fff;
    overflow-y: auto;

    ul {
      list-style-type: none;
      margin: 0;
      padding: 0;
      font-size: 14px;

      li {
        a {
          color: #333;
          padding: 10px 15px;
          display: block;
          text-decoration: none;
          -webkit-transition: color 0.2s linear;
          -moz-transition: color 0.2s linear;
          transition: color 0.2s linear;
          &.active {
            background: #d0d7dd;
          }
          &:hover {
            background: #d0d7dd;
          }

          span {
            background: #6c757d;
            color: #fff;
            padding: 0.25em 0.4em;
            font-size: 75%;
            font-weight: 700;
            line-height: 1;
            text-align: center;
            vertical-align: baseline;
            border-radius: 0.25rem;
            float: right;
          }
        }
      }
    }
  }

  &__content {
    position: fixed;
    top: 45px;
    left: 200px;
    width: calc(100% - 200px);
    height: calc(100% - 60px);
    overflow-y: auto;
  }
}

input,
select,
textarea {
  border: 1px solid #ccc;
  padding: 10px;
  width: calc(100% - 22px);
  border-radius: 4px;
  outline: none;

  &:focus {
    border: 1px solid #0839bc;
  }
}

select {
  width: 100%;
}

.form-group {
  margin-bottom: 15px;
}

button {
  background: #007bff;
  border: 0;
  border-radius: 0.3rem;
  color: #fff;
  padding: 0.4rem 1.2rem;
  text-decoration: none;
  text-align: center;
  user-select: none;
  padding: 4px 10px;
  cursor: pointer;
  transition: ease 0.2s all;

  &:hover {
    background: #0069d9;
  }
  &:active {
    background: #0056b1;
  }

  .icon {
    margin-top: 4px;
    margin-left: 10px;
  }
}

.toast {
  position: absolute;
  background: rgba(0, 0, 0, 0.5);
  width: calc(100% - 30px);
  bottom: 50%;
  left: 15px;
  border-radius: 6px;

  p {
    color: #fff;
    margin: 0;
    padding: 20px 15px;
    text-align: center;
  }
}

@keyframes flickerAnimation {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}
@-o-keyframes flickerAnimation {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}
@-moz-keyframes flickerAnimation {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}
@-webkit-keyframes flickerAnimation {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}

.animate-flicker {
  -webkit-animation: flickerAnimation 1s infinite;
  -moz-animation: flickerAnimation 1s infinite;
  -o-animation: flickerAnimation 1s infinite;
  animation: flickerAnimation 1s infinite;
}
</style>




// WEBPACK FOOTER //
// src/App.vue